import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./styles/index.css";
// Map Configuration
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import "mapbox-gl/dist/mapbox-gl.css";
import "maplibre-gl/dist/maplibre-gl.css";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import "./i18n";
import { store } from "./store/store";

dayjs.extend(utc);
dayjs.extend(timezone);


const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(

  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>

);


reportWebVitals();
